import { createTheme } from '@mantine/core';

export const theme = createTheme({
  // Maintain your existing theme settings
  primaryColor: 'blue',
  
  // By setting a specific value for components.Icon, we avoid the CSS variable issue
  components: {
    // Override the default Icon component to use fixed sizes instead of CSS variables
    Icon: {
      defaultProps: {
        // Use fixed pixel values instead of CSS variables for size
        size: '1rem',
        // Disable the use of CSS variables for stroke
        stroke: 1.5
      },
      styles: {
        // Provide fixed styles for SVG elements
        root: {
          // These styles will be applied to all icons
          '& svg': {
            // Use fixed values instead of calc() with CSS variables
            width: '1rem',
            height: '1rem'
          }
        }
      }
    }
  }
});
